import Cookies from 'js-cookie';
const app = {
  state: {
    aucRules: Cookies.getJSON('zy-live-paas-web-aucRules'),
    shopId: Cookies.getJSON('zy-live-paas-web-shopId'),
    token: null, // 因为这些参数是小程序URL链接里面带的，所以不用存Cookies
    qiniuToken: null,
  },

  mutations: {
    setAucRules(state, data) {
      state.aucRules = data;
      Cookies.set('zy-live-paas-web-aucRules', data);
    },
    setShopId(state, data) {
      state.shopId = data;
      Cookies.set('zy-live-paas-web-shopId', data);
    },
    setToken(state, data) {
      state.token = data;
    },
    setQiniuToken(state, data) {
      state.qiniuToken = data;
    },
  },

  actions: {
    setAucRules({ commit }, data) {
      commit('setAucRules', data);
    },
    setShopId({ commit }, data) {
      commit('setShopId', data);
    },
    setToken({ commit }, data) {
      commit('setToken', data);
    },
    setQiniuToken({ commit }, data) {
      commit('setQiniuToken', data);
    },
  },
};
export default app;
